module.exports = __webpack_public_path__ + "static/media/alert.0dcc12f0.wav";